/**
 * Import Dependency
 */
import React, { Component } from 'react'

// Libary
import qs from 'qs'
import { NavBar, ActivityIndicator, Modal } from 'antd-mobile'
import cx from 'classnames'
import lang from 'lodash/lang'
import injectSheet from 'react-jss'
import LinesEllipsis from 'react-lines-ellipsis'
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC'
import QrReader from 'react-qr-reader'
import _ from 'lodash'
import { Capacitor } from '@capacitor/core'
import { BarcodeScanner } from '@ionic-native/barcode-scanner'

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faQrcode, faGlobeAmericas, faSignOutAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { faFileAlt } from '@fortawesome/free-regular-svg-icons'

// CSS
import styles from '../assets/styles/components/NavBar'

// Container
import DialogComponent from './../containers/hoc/Dialog'

// Images
import logoImage from '../assets/images/logo.png'
import takeawayLogoImage from '../assets/images/takeaway-icon.jpg'
import URLParser from 'helpers/urlParser'

const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis)

class NavBarComponent extends Component {
  constructor (props) {
    super(props)
    const isWaiter = !!window.location.href.match(/waiter\.dimorder/)
    this.state = {
      isWaiter,
      displayQRcodeReader: false,
      qrstring: '',
      isLoading: false,
      completeDialogMessage: null,

      isOpenModal: false,
      isRightSideBarTriggerd: false,
      onLeftWidth: isWaiter ? 140 : window.innerWidth - 167 - 20, // Buffer 60 is am-navbar-title + am-navbar-right
    }
    this.defaultMerchantNameFontSize = 20 // Default 18px font-size for merchant name
    this.defaultMerchantNameHeight = 23 // Default 20px height for merchant height

    window.NavBarComponentQrCodeScan = (d) => { this.handleOnQrcodeScan(d) }
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.resizeDimension)
    this.resizeTimeout = setTimeout(() => {
      this.resizeDimension()
    })
  }

  componentWillUnmount=() => {
    window.removeEventListener('resize', this.resizeDimension)
    clearTimeout(this.resizeTimeout)
  }

  // > display QRcode result dialog
  componentDidUpdate = (prevState) => {
    const { intl } = this.props
    const { completeDialogMessage, isLoading } = this.state
    const title = intl.formatMessage({ id: 'dialog.scan_result' })
    const cancelButtonText = intl.formatMessage({ id: 'dialog.cancel_btn' })
    const confirmButtonText = intl.formatMessage({ id: 'dialog.rescan_btn' })
    if (!prevState.completeDialogMessage && completeDialogMessage && !isLoading) {
      this.renderQRcodeResultDialog(title, completeDialogMessage, cancelButtonText, confirmButtonText)
    }
  }

  renderQRcodeResultDialog = (title, message, cancelButtonText, confirmButtonText) => {
    Modal.alert(title, message, [
      {
        text: cancelButtonText,
        onPress: () => {
          this.setState({ completeDialogMessage: null })
        },
      },
      {
        text: confirmButtonText,
        onPress: () => {
          this.setState({ completeDialogMessage: null })
          this.setState({ displayQRcodeReader: true })
        },
      },
    ])
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.resizeDimension)
  }

  resizeDimension = () => {
    const width = this.state.isWaiter ? 140 : window.innerWidth - 100
    this.setState({
      onLeftWidth: width,
    })
  }

  onSetRightSidebarOpen = (isRightSideBarTriggerd) => {
    this.setState({ isRightSideBarTriggerd })
    this.props.switchRightSideBar(isRightSideBarTriggerd)
  }

  switchRightSideBar = (event) => {
    event.preventDefault()
    this.onSetRightSidebarOpen(!this.state.isRightSideBarTriggerd)
  }

  handleRouteToRoot = (event) => {
    event.preventDefault()
    const { history } = this.props
    const path = '/home'
    history.push(path)
  }

  handleRouteToCheckout = (event) => {
    event.preventDefault()
    const { history } = this.props
    const path = '/basket/checkout'
    history.push(path)
  }

  handleOpenSwitchLangModal = () => {
    this.setState({
      isOpenModal: !this.state.isOpenModal,
    })
  }

  handleGoToHistory = () => {
    const { history } = this.props
    const path = {
      pathname: '/basket/history',
      state: {
        from: history.location.pathname,
      },
    }
    history.push(path)
    console.info('route changed', path)
  }

  openScanner = async () => {
    this.props.intl.formatMessage({ id: 'dialog.camera_failure' })
    try {
      const scanData = await BarcodeScanner.scan({
        // prompt: '對準 QRCode',
        formats: 'QRCode',
      })
      this.handleOnQrcodeScan(scanData.text)
    } catch (error) {
      console.log('BarcodeScanner error', error)
      alert('相機啟動失敗')
    }
  }

  // > on scan handle function
  handleOnQrcodeScan = (data) => {
    if (data) {
      this.setState({ qrstring: data })
      const actionType = data.split(':')[0]

      if (actionType === 'completeTakeawayOrder') {
        this.setState({
          isLoading: true,
          displayQRcodeReader: false,
        })
        this.completeTakeawayOrder(data)
      }
    }
  }

  completeTakeawayOrder = _.debounce(async (data) => {
    const { intl, completeTakeawayOrder } = this.props
    const pickUpSuccessText = intl.formatMessage({ id: 'dialog.pickup_success' })
    const pickUpFailedText = intl.formatMessage({ id: 'dialog.pickup_failed' })

    const renderErrorMessage = (status) => {
      const errorMessage500 = intl.formatMessage({ id: 'dialog.pickup_error_status.500' })
      const errorMessage402 = intl.formatMessage({ id: 'dialog.pickup_error_status.402' })
      const errorMessage403 = intl.formatMessage({ id: 'dialog.pickup_error_status.403' })
      switch (status) {
        case 402:
          return errorMessage402
        case 403:
          return errorMessage403
        case 500:
          return errorMessage500
        default:
          break
      }
    }

    try {
      const order = await completeTakeawayOrder(data)

      this.setState({
        completeDialogMessage: `#${order.data.orderSerial} \n${pickUpSuccessText}`,
        isLoading: false,
      })
    } catch (err) {
      this.setState({
        completeDialogMessage: `${pickUpFailedText} (${renderErrorMessage(err.response.status)})`,
        isLoading: false,
      })
    }
  }, 1000)

  switchLang = (lang, index) => {
    const {
      switchLocale,
      setUserLocale,
      merchant,
    } = this.props

    this.setState({
      isOpenModal: false,
    }, async () => {
      await switchLocale(merchant.clientLocales[index])
      await setUserLocale(merchant.clientLocales[index])
      const url = window.location.href
      if (url && url.includes('&l=')) {
        const urlArray = String(url).split('&')
        const index = urlArray.findIndex(u => u.includes('l='))
        urlArray.splice(index, 1)
        window.location.href = urlArray.join('&')
      } else {
        window.location.reload()
      }
    })
  }

  renderSwitchLangDialogComponent = () => {
    const {
      // history,
      merchant,
      intl,
    } = this.props

    const _list = [
    ]

    if (
      merchant == null ||
      merchant.clientLocales === undefined ||
      merchant.clientLocales == null
    ) {
      // do nothing before getting clientLocales from server
      return
    } else {
      merchant.clientLocales.forEach(element => {
        _list.push(intl.formatMessage(
          { id: 'lang.' + element, value: element },
        ))
      })
    }

    if (this.state.isOpenModal) {
      return (
        <DialogComponent
          triggerModal={this.switchLang}
          dialogType='operation'
          list={_list}
          onClose={() => {
            this.setState({
              isOpenModal: false,
            })
          }}
        />
      )
    }
  }

  render () {
    const {
      classes,
      history,
      categories,
      user,
      merchant,
      isTakeawaySummary,
      isTakeaway,
      updateSearchModeDisplay, // > display search mode. (true)
      getCommodities, // > get all commodities of this merchant by merchant.id.
      updateNavBarSwiperExpand,
    } = this.props
    const path = history.location.pathname

    const isWaiter = merchant && user && user.permissions && user.permissions.indexOf(merchant.id + ':waiter') >= 0
    const navBarStyle = cx(classes['overwrite-navbar'])
    const navbarIconsWrapStyle = cx(classes['navbar-icons-wrap'])
    const navbarIconStyle = cx(classes['navbar-icon'])
    const qrcodeReaderWrapStyle = cx(classes['qrcode-reader-wrap'])
    const qrcodeReaderStyle = cx(classes['qrcode-reader'])

    let merchantNameElement = ''

    let navImage = ''
    if (isTakeaway) {
      navImage = takeawayLogoImage
    } else {
      navImage = logoImage
    }

    let rightContent = ''
    if (isTakeawaySummary) {
      rightContent = (
        <React.Fragment>
          <div
            style={{ right: '10px' }}
            className={navbarIconStyle}
            onClick={this.handleOpenSwitchLangModal}
          >
            <FontAwesomeIcon icon='globe-americas' />
          </div>
          {this.renderSwitchLangDialogComponent()}
        </React.Fragment>)
    } else {
      rightContent = (
        <div className={navbarIconsWrapStyle}>
          {/**
            // > display a search icon button only in waiter mode which can open a search mode and get all commodities of this merchant.
            // > use search bar to fillter all the commodities by CODE (the customized code) or DISH (the name of item).
            // > type in '@all' will display ALL COMMODITES of this merchant.
            // > type in '@set' will display ALL SETS of this merchant.
          */}
          {isWaiter && (
            <React.Fragment>
              {// > qrcode reader
                (!Capacitor.isNative && this.state.displayQRcodeReader) && (
                  <div
                    className={qrcodeReaderWrapStyle}
                    onClick={() => this.setState({ displayQRcodeReader: false })}
                  >
                    <QrReader
                      className={qrcodeReaderStyle}
                      delay={300} // > scan every 300 ms
                      onError={error => console.log('error', error)}
                      onScan={this.handleOnQrcodeScan}
                    />
                  </div>
                )
              }
              <div
                className={navbarIconStyle}
                onClick={() => {
                  const fistNotSetCategoryId = categories.find(category => !category.isSet).id
                  const path = `/category/${fistNotSetCategoryId}`
                  history.push(path)
                  getCommodities(merchant.id)
                  updateSearchModeDisplay(true)
                  updateNavBarSwiperExpand(false)
                }}
              >
                <FontAwesomeIcon icon={faSearch} />
              </div>
              <div
                className={navbarIconStyle}
                onClick={() => {
                  // > display qrcode reader
                  this.setState({ displayQRcodeReader: true })
                  if (Capacitor.isNative) {
                    this.openScanner()
                  }
                }}
              >
                <FontAwesomeIcon icon={faQrcode} />
              </div>
            </React.Fragment>
          )}

          <div
            className={navbarIconStyle}
            onClick={this.handleOpenSwitchLangModal}
          >
            <FontAwesomeIcon icon={faGlobeAmericas} />
          </div>

          <div
            className={navbarIconStyle}
            onClick={this.handleGoToHistory}
          >
            <FontAwesomeIcon icon={faFileAlt} />
          </div>
          {this.renderSwitchLangDialogComponent()}
          {
            // signout btn
            isWaiter &&
            (
              Capacitor.isNative || window.localStorage.getItem('waiter-login')
            ) && (
              <React.Fragment>
                <div
                  className={navbarIconStyle}
                  onClick={() => {
                    this.props.logout()
                    window.location.href = [`${window.location.protocol}//`, window.location.host, '?requireWaiterLogin=true'].join('')
                  }}
                >
                  <FontAwesomeIcon icon={faSignOutAlt} />
                </div>
              </React.Fragment>
            )
          }
        </div>)
    }

    if (!lang.isEmpty(merchant)) {
      merchantNameElement = (
        <div
          ref={ref => {
            if (!lang.isEmpty(ref)) {
              ref.style.fontSize = this.defaultMerchantNameFontSize + 'px'

              if (ref.style.fontSize !== '16px') {
                const _offsetHeight = ref.offsetHeight
                if (_offsetHeight > this.defaultMerchantNameHeight) {
                  ref.style.fontSize = '16px'
                } else {
                  ref.style.fontSize = this.defaultMerchantNameFontSize + 'px'
                }
              }
            }
          }}
        >
          <ResponsiveEllipsis
            text={`${merchant.name}`}
            maxLine='2'
            ellipsis='...'
            trimRight
            basedOn='letters'
          />
        </div>
      )
    }

    let onLeftClick = this.handleRouteToRoot
    const backBtn = <div style={{
      width: '44px',
      height: '24px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }} >
      <FontAwesomeIcon icon={faArrowLeft} />
    </div>
    let showBackBtn = false

    if (isTakeawaySummary) {
      onLeftClick = this.handleRouteToCheckout
      showBackBtn = true
    }
    if (_.get(this.props.form, 'datetime')) {
      if (!isTakeawaySummary) {
        const handleBackToForm = () => {
          const params = qs.stringify({
            m: merchant.id,
            dir: true,
            ..._.get(this.props.query, 'params.pkg') && { pkg: this.props.query.params.pkg },
            ..._.get(this.props.basket, 'promoCode') && { c: this.props.basket.promoCode },
          })
          window.location.href = `${window.location.protocol}//${window.location.host}?${params}`
        }
        onLeftClick = handleBackToForm
      }
      showBackBtn = true
    }
    const isTakeawayWaiting = path === '/basket/takeaway_waiting'
    if (isTakeawayWaiting) {
      onLeftClick = () => {}
      showBackBtn = false
    }

    return (
      <React.Fragment>
        <NavBar
          className={navBarStyle}
          mode='light'
          onLeftClick={onLeftClick}
          leftContent={
            <div
              style={{
                width: this.state.onLeftWidth + 'px',
              }}
            >
              {showBackBtn && backBtn}
              <img className={isTakeaway ? 'takeaway' : ''} src={navImage} alt='' />
              {merchantNameElement}
            </div>
          }
          rightContent={rightContent}
        />

        { // > Loading
          this.state.isLoading && (
            <div style={{ position: 'fixed', height: '100%', width: '100%', top: '0px', zIndex: 99999 }}>
              <div style={{ height: '100%', position: 'absolute', width: '100%', textAlign: 'center', top: '0px', background: '#000', opacity: '0.2' }} />
              <div style={{ position: 'absolute', top: 'calc(50% - 16px)', left: 'calc(50% - 16px)' }}>
                <ActivityIndicator size='large' />
              </div>
            </div>
          )
        }
      </React.Fragment>
    )
  }
};

/**
 * Export
 */
export default injectSheet(styles)(NavBarComponent)



// WEBPACK FOOTER //
// ./src/components/NavBar.js